import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import { connect } from 'react-redux'

import Collapse from './Collapse'
import CheckboxLine from './CheckboxLine'
import Features from './Features'

import { selectPbxPlan } from '../store/actions/HostedPbxActions'
import { toggleAddOnFeature } from '../store/actions/DialingPlansActions'

class HostedPBX extends Component {

    selectPbxPlant(planId, planPrice) {
        const { AddOnFeatures } = this.props.DialingPlansReducer;
        if(
            (planId == "CALL_CENTER" && !!AddOnFeatures.find(item => item.id == "ACTIVE_AGENT_PANEL"))
            ||
            (planId == "FREE" && AddOnFeatures.find(item => item.id == "ACTIVE_AGENT_PANEL"))
        ) {
            this.toggleAddOnFeature("ACTIVE_AGENT_PANEL", 0)
        }
        this.props.selectPbxPlan(planId, planPrice);
    }

    toggleAddOnFeature(planId, planPrice) {
        this.props.toggleAddOnFeature(planId, planPrice);
    }

    render() {
        const { HostedPbxPlan } = this.props;
        const { AddOnFeatures } = this.props.DialingPlansReducer;

        const cloudExt = (
            <CheckboxLine 
                content={
                    <div>
                        Platform Access Fee 
                        <span style={{fontSize: ".85rem"}}
                            > (Per Extension) - <Link to="/shop/dialing-plan" style={{color: "inherit"}}>
                                <u>Select Quantity</u>
                            </Link>
                        </span>
                    </div>
                } 
                checkboxProps={{
                    title: "$0.00/month",
                    active: HostedPbxPlan.id == "FREE", 
                    onChange: () => {this.selectPbxPlant("FREE", 0) }
                }} />
        );
        const hostedPhone = (
            <div>
                <CheckboxLine 
                    content={[<div>HostedPBX Basic</div>,<div>Up to 20 Extensions</div>]}
                    checkboxProps={{
                        title: "$49.99/month", 
                        active: HostedPbxPlan.id == "BASIC", 
                        onChange: () => this.selectPbxPlant("BASIC", 49.99)
                }}/>
                <CheckboxLine 
                    content={[<div>HostedPBX Professional</div>,<div>Up to 40 Extensions</div>]}
                    checkboxProps={{
                        title: "$79.99/month", 
                        active: HostedPbxPlan.id == "PRO",
                        onChange: () => {this.selectPbxPlant("PRO", 79.99) }
                }} />
                <CheckboxLine 
                    content={[<div>HostedPBX Call Center</div>,<div>Up to 60 Extensions with Active Agent Panel</div>]}
                    checkboxProps={{
                        title: "$129.99/month",
                        active: HostedPbxPlan.id == "CALL_CENTER", 
                        onChange: () => {this.selectPbxPlant("CALL_CENTER", 129.99) }
                }} />
                <CheckboxLine 
                    content={[<div>Hosted Call Center- Vici-Dialer</div>,<div>Predictive Dialer</div>]}
                    checkboxProps={{
                        title: "*$99.99/month", 
                        active: HostedPbxPlan.id == "VICI", 
                        onChange: () => {this.selectPbxPlant("VICI", 99.99) }
                }} />
                <CheckboxLine 
                    content={[<div>Complete Call Center Solution</div>,<div>Predictive Dialer + PBX</div>]}
                    checkboxProps={{
                        title: "*$129.99/month", 
                        active: HostedPbxPlan.id == "PRED_AND_PBX", 
                        onChange: () => {this.selectPbxPlant("PRED_AND_PBX", 129.99) }
                }} />
                <div style={{display: "flex", justifyContent: "flex-end"}}><i>* $99 one time set up fee</i></div>
            </div>
        );

        const pbxFeatures = (
            <Features title="PBX features" titleColor="#F89406" items={[
                "Call Transfer/Forwarding",
                "Voicemail/Voicemail to Email",
                "Follow Me",
                "Auto-Attendant/IVR",
                "Do Not Disturb",
                "Ext. to Ext. calling",
                "Music On Hold",
                "Office Hours",
                "Remote Users",
                "Multiple Offices",
                "Call Parking",
                "Call Queue",
                "Ring Groups",
                "Call Reporting",
                "Caller ID",
                "Phone Directory",
                "Conference Rooms",
                "call Recordings",
                "and much more…",
            ]} />
        );
        const keyFeatures = (
            <Features title="Key Advantages" titleColor="#F89406" items={[
                "Don't buy expensive equipment",
                "Complete Cloud Services with Cutting Edge Features",
                "Easily scalable as you grow",
                "Geographical Flexibility",
                "Easy to Use",
                "Quick, turnkey setup",
                "Work with most VoIP Phones",
            ]} />
        );

        const addOnFeaturesUI = (
            <div>
                <CheckboxLine content={
                    [<div>Call Recording</div>,
                    <div>All calls, Per system</div>]
                    }
                    hideCheckbox={false}
                    checkboxProps={{
                        title: "$20/month", 
                        active: !!AddOnFeatures.find(item => item.id == "CALL_RECORDING"),
                        onChange: () => { this.toggleAddOnFeature("CALL_RECORDING", 20) }
                }} />
                <CheckboxLine content={
                    [<div>Active Agent Panel</div>,
                    <div>$99 (one time fee)</div>]
                    }
                    hideCheckbox={false}
                    checkboxProps={
                        HostedPbxPlan.id == "CALL_CENTER" ? 
                        {
                            title: "Included", 
                            active: true,
                        }
                        :
                        HostedPbxPlan.id == "FREE" ? 
                        {
                            title: "Ineligible",
                            active: false,
                        } :
                        {
                            title: "$20/month", 
                            active: !!AddOnFeatures.find(item => item.id == "ACTIVE_AGENT_PANEL"),
                            onChange: () => { this.toggleAddOnFeature("ACTIVE_AGENT_PANEL", 20) }
                        }
                    }
                 />
                <CheckboxLine content={
                    [<div>Do-It-Yourself Configuration</div>,
                    <div>FREE</div>,<div></div>]
                    }
                    hideCheckbox={true}
                />
                <CheckboxLine content={
                    [<div>Initial HostedPBX Configuration</div>,
                    <div>$199 (one time fee)</div>,
                    <div style={{textAlign: "right", color: "#F89406"}}>Waived with all qualified packages</div>]
                    }
                    hideCheckbox={true}
                />
                <CheckboxLine content={
                    [<div>Hourly Remote Support/Config</div>,
                    <div>$95/hour</div>,
                    <div style={{textAlign: "right"}}>Minimum 60 min, then every 30 min</div>]
                    }
                    hideCheckbox={true}
                />
                <CheckboxLine content={
                    [<div>Optional Predictive-Dialer support plan</div>,
                    <div>$250/month</div>,
                    <div style={{textAlign: "right"}}>Monthly plan with 12 month Commitment</div>]
                    }
                    hideCheckbox={true}
                />
                {pbxFeatures}
                {keyFeatures}
            </div>
        );

        return (
            <div>
                <div style={{margin: "1.5vh 1.5vw", textAlign: "center"}}><i>* PBX orders are processed within 1 to 3 business days from the time placed, varied by the speed we collect the desired specs from you.</i></div>
                <Collapse defaultActiveKey={["0", "1", "2"]} items={[
                    {headerTitle: "Cloud PBX Extension/s", content: cloudExt}, 
                    {headerTitle: <div><b>Dedicated</b> Hosted Phone System</div>, content: hostedPhone},
                    {headerTitle: "Optional Add-On Features", 
                        content: addOnFeaturesUI}
                ]} />
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        HostedPbxPlan: state.HostedPbxReducer.HostedPbxPlan,
        DialingPlansReducer: state.DialingPlansReducer,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        selectPbxPlan: (planId, planPrice) => dispatch(selectPbxPlan(planId, planPrice)),
        toggleAddOnFeature: (planId, planPrice) => dispatch(toggleAddOnFeature(planId, planPrice)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(HostedPBX);